import { Image, ImageStyle, StyleProp, View, ViewStyle } from "react-native"

export interface FleetHubLogoProps {
  /**
   * The width of the logo. Height will be calculated to maintain aspect ratio.
   * Default: 200
   */
  width?: number

  /**
   * Style overrides for the logo image
   */
  style?: StyleProp<ImageStyle>

  /**
   * Style overrides for the logo container
   */
  containerStyle?: StyleProp<ViewStyle>
}

/**
 * FleetHub branding logo component
 * Displays the FleetHub logo with "Hol Deine Plakette.de" and KÜS branding
 */
export function FleetHubLogo(props: FleetHubLogoProps) {
  const { width = 200, style: $imageStyleOverride, containerStyle: $containerStyleOverride } = props

  // Logo has aspect ratio of approximately 700:250 (2.8:1)
  const height = width / 2.8

  const $imageStyle: StyleProp<ImageStyle> = [
    {
      width,
      height,
    },
    $imageStyleOverride,
  ]

  return (
    <View style={$containerStyleOverride}>
      <Image
        style={$imageStyle}
        source={require("@assets/images/FleetHubLogo.png")}
        resizeMode="contain"
        accessibilityLabel="FleetHub Logo"
      />
    </View>
  )
}
